export enum PopoverPlacement {
  top = 'top',
  left = 'left',
  right = 'right',
  bottom = 'bottom',
}
